import(/* webpackMode: "eager" */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\register\\page.tsx");
